import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Autocomplete, Button, Divider, Stack, TextField, Typography } from "@mui/material"

import { useForm } from '../../../../hooks';
import { PrincipalLayouts } from '../../../../layouts';
import { NumberInput } from '../../NumberInput';
import { Field } from '../../miProfile/Field';
import { fetchData } from '../../../helpers/getData/fetchData';
import { createFundDistribution } from '../../../helpers/fundDistribution';
import { DateInput } from '../../DateInput';
import { toEnglishDate } from '../../../../helpers/dateFormat';

export const AddDistribution = () => {

    const navigate = useNavigate();
    const { t } = useTranslation('global');
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [isWaiting, setIsWaiting] = useState(false);
    const [startupList, setStartupList] = useState('isLoading');
    const [vehiclesList, setVehiclesList] = useState('isLoading');
    const date = new Date();
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const actualDate = date.toLocaleDateString("es-ES", options);

    const [formValues, handleInputChange, reset] = useForm({ investmentType: 'Ampliación Capital', urlVideo: '', amountToInvest: '', startupName: '', participationValuation: '', investmentDate: toEnglishDate(actualDate) });

    const { investmentType, urlVideo, amountToInvest, startupName, participationValuation, investmentDate } = formValues;

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsWaiting(true)
        const participation = investmentType === 'Préstamo Convertible' ? null : participationValuation
        const video = urlVideo === '' ? null : urlVideo
        createFundDistribution({ ...formValues, fundId: searchParams.get('fund'), amount: amountToInvest, startupId: startupList.filter(startup => startup.name === startupName)[0]?.id, participationValuation: participation, urlVideo: video }, t('fundDistributions.addSuccesMsg'), t('fundDistributions.addErrorMsg'), navigate)
        setIsWaiting(false)
        reset()
    }

    const handleCancel = () => {
        reset();
        navigate(-1)
    }

    useEffect(() => {
        fetchData(setStartupList, '/startups/getNameList', t)
        fetchData(setVehiclesList, '/vehicle/nameList', t)
    }, [t])

    return (
        <PrincipalLayouts>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography color='primary' variant='h5'>{t('fundDistributions.addFundDistribution')}</Typography>
            </Stack>
            <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

            <form onSubmit={handleConfirm}>
                <Stack minHeight='calc(100vh - 290px)' gap={2}>
                    {
                        (startupList !== 'isLoading' && vehiclesList !== 'isLoading') &&
                        <>
                            <Stack direction='column' width='100%' gap={0}>
                                <Typography variant='overline' color='secondary'>{t('fundDistributions.startups')}</Typography>
                                <Autocomplete
                                    disablePortal
                                    options={[...startupList.map(startup => startup.name), '']}
                                    size='small'
                                    renderInput={(params) => <TextField  {...params} variant='outlined' name='startupName' />}
                                    value={startupName}
                                    onSelect={handleInputChange}
                                    fullWidth
                                    required
                                />
                            </Stack>

                            <Stack direction='column' width='100%' gap={0}>
                                <Typography variant='overline' color='secondary'>{t('fundDistributions.investmentType')}</Typography>
                                <Autocomplete
                                    disablePortal
                                    options={['Préstamo Convertible', 'Ampliación Capital']}
                                    size='small'
                                    renderInput={(params) => <TextField  {...params} variant='outlined' name='investmentType' />}
                                    value={investmentType}
                                    onSelect={handleInputChange}
                                    fullWidth
                                    required
                                />
                            </Stack>

                            <Stack direction='row' width='100%' gap={2}>
                                <NumberInput min={2000} name={amountToInvest} title='amountToInvest' handleInputChange={handleInputChange} required={true} />
                                <NumberInput min={0} name={participationValuation} title='participationValuation' handleInputChange={handleInputChange} required={true} isDisabled={investmentType === 'Préstamo Convertible' ? true : false} />
                            </Stack>

                            {
                                searchParams.get('hasVideo') === '0' &&
                                <Stack>
                                    <Field translation={'fundDistributions'} name={urlVideo} title='urlVideo' handleInputChange={handleInputChange} required={true} />
                                </Stack>
                            }

                            <Stack>
                                <DateInput translation={'fundDistributions'} name={investmentDate} title='investmentDate' handleInputChange={handleInputChange} required={true} />
                            </Stack>

                        </>
                    }

                </Stack>

                <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
                    <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
                    <Button disabled={isWaiting || (startupName === '')} sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
                </Stack>
            </form>

        </PrincipalLayouts>
    )
}